import { types } from "../types/types";

const initialState = {
	isModalOpen: false
};
export const viewModalReducer = (state = initialState, action) => {
	switch (action.type) {
		case types.VIEW_MODAL_OPEN:
			return {
				...state,
				isModalOpen: true
			};

		case types.VIEW_MODAL_CLOSE:
			return {
				...state,
				isModalOpen: false
			};

		default:
			return state;
	}
};